import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';

const styles = css`
  background-image: url('/images/coming-soon.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 25vh;
  width: 100%;
`;

function DetailHeaderWrapper({ className, children, imageUrl }) {
  let mergedStyles = cx(styles, className);
  if (imageUrl) {
    const imageCss = css(`background-image: url('${buildThumbnailUrl(imageUrl, { width: 2000, height: 2000 })}');`);
    mergedStyles = cx(mergedStyles, imageCss);
  }
  return (
    <div
      className={mergedStyles}
    >
      {children}
    </div>
  );
}

DetailHeaderWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  imageUrl: PropTypes.string,
};

DetailHeaderWrapper.defaultProps = {
  className: undefined,
  children: undefined,
  imageUrl: undefined,
};

export default DetailHeaderWrapper;



// WEBPACK FOOTER //
// ./src/components/DetailHeaderWrapper.js